import { Stack, Typography } from '@mui/material'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'react-i18next'
import { generateSupplierRoute } from '@omnea-app/fe-suppliers/details/generateSupplierRoute'
import { InfiniteScrollLoader } from '@omnea-app/fe-tables/mobile/InfiniteScrollLoader'
import { EmptyMentionList } from './components/EmptyMentionList'
import { MentionSkeletonList } from './components/MentionSkeletonList'
import { ResolveAllButton } from './components/ResolveAllButton'
import { ResolveButtons } from './components/ResolveButtons'
import { getFormCommentLink, getMentionTitle } from './helpers'
import { MentionBox } from './MentionBox'
import { MentionListViewProps } from './types'

export const MentionListMobileView = ({
  loading,
  unresolvedMentionsCount,
  setShowResolved,
  showResolved,
  markAllMentionsResolved,
  displayedMentions,
  loadMore,
  hasMore,
}: MentionListViewProps) => {
  const { t } = useTranslation('dashboard')

  return (
    <Stack>
      <Stack gap={3}>
        <Typography variant="H6Semibold">{t('mentions.title')}</Typography>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <ResolveButtons
            loading={loading}
            unresolvedMentionsCount={unresolvedMentionsCount}
            handleResolveChange={setShowResolved}
            showResolved={showResolved}
            translate={t}
          />
          <Stack>
            {!showResolved && unresolvedMentionsCount !== 0 && (
              <ResolveAllButton markAllMentionsResolved={markAllMentionsResolved} translate={t} />
            )}
          </Stack>
        </Stack>
        <Stack gap={2}>
          {loading && <MentionSkeletonList />}

          {!loading &&
            displayedMentions &&
            displayedMentions.map(
              (mention) =>
                mention.comment && (
                  <MentionBox
                    key={mention.id}
                    id={mention.id}
                    comment={mention.comment}
                    createdAt={mention.createdAt || ''}
                    name={getMentionTitle(mention)}
                    targetUrl={getFormCommentLink(mention, generateSupplierRoute)}
                    isResolved={mention.isResolved}
                    requestId={mention.requestId}
                  />
                )
            )}
          {!isEmpty(displayedMentions) && <InfiniteScrollLoader hasMoreItems={hasMore} onReveal={loadMore} />}

          {!loading && displayedMentions && isEmpty(displayedMentions) && <EmptyMentionList showResolved={showResolved} />}
        </Stack>
      </Stack>
    </Stack>
  )
}
